import { createContext, useContext, useState, ReactNode } from 'react';

type UnsavedChangesContextType = {
	hasUnsavedChanges: boolean;
	setHasUnsavedChanges: (value: boolean) => void;
	pendingRoute: string | null;
	setPendingRoute: (route: string | null) => void;
	isModalOpen: boolean;
	setIsModalOpen: (open: boolean) => void;
};

const UnsavedChangesContext = createContext<
	UnsavedChangesContextType | undefined
>(undefined);

export function UnsavedChangesProvider({ children }: { children: ReactNode }) {
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
	const [pendingRoute, setPendingRoute] = useState<string | null>(null);
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<UnsavedChangesContext.Provider
			value={{
				hasUnsavedChanges,
				setHasUnsavedChanges,
				pendingRoute,
				setPendingRoute,
				isModalOpen,
				setIsModalOpen,
			}}
		>
			{children}
		</UnsavedChangesContext.Provider>
	);
}

export function useUnsavedChanges() {
	const context = useContext(UnsavedChangesContext);
	if (!context) {
		throw new Error(
			'useUnsavedChanges must be used within UnsavedChangesProvider'
		);
	}
	return context;
}
